import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { UserManagementDialogsObject } from '@databox/ember-integrations/lib/components/UserManagement/UserManagementDialogs';
import UserManagementDialogs from '@databox/ember-integrations/lib/components/UserManagement/UserManagementDialogs';

import type { ReactIntegrations, Service } from 'webapp-types';
import { AppEvent } from 'webapp/enums/events';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';

export default class UserManagementManagerComponent extends Component {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('user-management') declare userManagementService: Service.UserManagement;
	@service('event-manager') declare eventManagerService: Service.EventManager;
	@service('react') declare reactService: Service.React;

	reactElement: ReactIntegrations.Root = null;

	@action
	onReactInit(args: UserManagementDialogsObject) {
		this.userManagementService.userManagementFunctions = args;
	}

	@action
	setupView(node: HTMLElement) {
		this.reactElement = this.reactService.create(node as HTMLDivElement);
		this.renderUserManagement();

		this.eventManagerService.on(AppEvent.THEME_CHANGED, this, this.renderUserManagement);
	}

	renderUserManagement() {
		const { accessToken, userDataToken: dataToken } = this.currentUserService;

		const props = {
			onInit: this.onReactInit,
			accessToken: accessToken!,
			dataToken: dataToken!,
			isDarkThemeActive: this.navigationService.theme.isDark,
			spaceId: this.accountService.id,
		};

		if (this.reactElement) {
			this.reactService.render(this.reactElement, UserManagementDialogs(props));
		}
	}

	@action
	teardownView() {
		this.reactService.unmount(this.reactElement);
		this.eventManagerService.off(AppEvent.THEME_CHANGED, this);
	}

	<template>
		<div {{didInsert this.setupView}} {{willDestroy this.teardownView}}></div>
	</template>
}
